module.exports = __webpack_public_path__ + "static/media/planta-min.e62a29ff.jpg";